// extracted by mini-css-extract-plugin
export var addButton = "_v-g";
export var cartCardSlider = "_v-c";
export var cartContainer = "_v-17";
export var cartPreview = "_v-16";
export var cartTotal = "_v-1c";
export var chartContainer = "_v-1u";
export var chartLoading = "_v-1v";
export var checkoutButton = "_v-1i";
export var checkoutButtonContainer = "_v-1b";
export var checkoutContainer = "_v-1k";
export var checkoutPreview = "_v-1j";
export var coveragePreview = "_v-z";
export var dark = "_v-15";
export var editorStyleIcon = "_v-w";
export var errorText = "_v-1s";
export var fakeCheckoutCheckbox = "_v-1q";
export var fakeCheckoutContainer = "_v-1m";
export var fakeCheckoutImage = "_v-1n";
export var fakeCheckoutTextContainer = "_v-1o";
export var fakeCheckoutTitle = "_v-1p";
export var fakeProduct = "_v-1d";
export var fakeProductImage = "_v-1f";
export var fakeProductInfo = "_v-1g";
export var fakeProductPrice = "_v-1h";
export var fakeRedoToggle = "_v-1e";
export var fullCartContainer = "_v-19";
export var fullCartHeader = "_v-18";
export var fullWidth = "_v-0";
export var generalSettingsToggle = "_v-f";
export var hoverable = "_v-x";
export var icon = "_v-1";
export var iconButtonContainer = "_v-1t";
export var light = "_v-13";
export var medium = "_v-14";
export var modalDescription = "_v-l";
export var modalLeftButton = "_v-k";
export var navigateIcon = "_v-y";
export var newSplitModal = "_v-j";
export var payNowButton = "_v-1l";
export var previewLink = "_v-2";
export var previewStyleSelector = "_v-10";
export var previewStyleSelectorSizer = "_v-11";
export var pricingSettingBlock = "_v-1r";
export var quarterCartContainer = "_v-1a";
export var richTextEditor = "_v-u";
export var richTextLabel = "_v-v";
export var selected = "_v-t";
export var selectedSplitType = "_v-p";
export var sidebarContent = "_v-9";
export var sidebarContentSection = "_v-a";
export var sidebarPaddedRow = "_v-d";
export var sidebarSectionHeader = "_v-7";
export var sidebarSectionTitle = "_v-8";
export var sidebarSettingRow = "_v-b";
export var sidebarStyleSelector = "_v-e";
export var skeletonBlock = "_v-12";
export var splitContent = "_v-q";
export var splitContentContainer = "_v-5";
export var splitFooterContainer = "_v-r";
export var splitFormActions = "_v-i";
export var splitHeaderContainer = "_v-h";
export var splitName = "_v-3";
export var splitPage = "_v-4";
export var splitSidebarContainer = "_v-6";
export var splitTypeContainer = "_v-m";
export var splitTypeDescription = "_v-o";
export var splitTypeSelection = "_v-n";
export var treatmentNameButton = "_v-s";